
import { supabase } from '../../client';
import { UpdatePaymentSettingsParams } from '../types';
import { getShopPaymentSettings } from './getShopPaymentSettings';

/**
 * Met à jour les paramètres de paiement d'une boutique
 */
export async function updateShopPaymentSettings(
  shopId: string, 
  settings: UpdatePaymentSettingsParams
): Promise<{ success: boolean; error?: any }> {
  try {
    // Vérifier si un enregistrement existe déjà
    const existingSettings = await getShopPaymentSettings(shopId);
    
    if (!existingSettings) {
      return { success: false, error: "Impossible de trouver ou créer les paramètres de paiement" };
    }
    
    const { error } = await supabase
      .from('ecom_payment_settings')
      .update(settings)
      .eq('shop_id', shopId);

    if (error) {
      console.error('[updateShopPaymentSettings] Error:', error);
      return { success: false, error };
    }

    return { success: true };
  } catch (error) {
    console.error('[updateShopPaymentSettings] Exception:', error);
    return { success: false, error };
  }
}
